// extracted by mini-css-extract-plugin
module.exports = {"cancel":"cancel-1s_ms","confirm":"confirm-249Gt"};